export const HRA_STORE_ANALYTICS = 'analytics';
export const HRA_STORE_REVIEW_ANALYTICS = 'analytics/reviewAnalytics';
export const HRA_STORE_REVIEWS = 'analytics/reviews';
export const HRA_STORE_COMPARATIVE_STUDY = 'analytics/comparativeStudy';

export const HRA_FETCH_DYNAMIC_CHART_DATA = 'fetchDynamicChartData';
export const HRA_FETCH_SOURCES_BY_COUNTRY_DATA = 'fetchSourcesByCountryData';
export const HRA_FETCH_COUNTRIES_BY_SOURCE_DATA = 'fetchCountriesBySourceData';
export const HRA_FETCH_DISTRIBUTION_DATA = 'fetchDistributionData';
export const HRA_FETCH_TOP_USED_KEYWORDS = 'fetchTopKeywords';
export const HRA_FETCH_REVIEW_SENTIMENTS = 'fetchReviewSentiments';
export const HRA_FETCH_SENTIMENTS_BY_DATE = 'fetchSentimentsByDate';
export const HRA_FETCH_WEAKNESS_DATA = 'fetchWeaknessData';
export const HRA_FETCH_SENTIMENTS_TABLE_DATA = 'fetchSentimentsTableData';
export const HRA_FETCH_ANNUAL_COMPARISON = 'fetchAnnualComparison';

export const HRA_FETCH_CATEGORY_BASED_DATA = 'fetchCategoryBasedData';
export const HRA_FETCH_OVERALL_TRENDS_DATA = 'fetchOverallTrendsData';
export const HRA_FETCH_CATEGORY_TRENDS_DATA = 'fetchCategoryTrendsData';
export const HRA_FETCH_COMPETITOR_REVIEWS_DATA = 'fetchCompetitorReviewsData';

export const HRA_FETCH_REVIEWS = 'fetchReviews';
export const HRA_FETCH_REVIEWS_DATA = 'fetchReviewsData';
export const HRA_FETCH_REVIEW_COUNTRIES = 'fetchReviewCountries';

export const HRA_TOP_USED_KEYWORDS_COUNT = 30;
export const HRA_HOTEL_LIMITATION = 5;
